// src/UserDetails/msalConfig.js
import { PublicClientApplication } from "@azure/msal-browser";

const getRedirectUri = () => {
  return "https://tuition-reimbursement.pharmavite.com/";
};

const msalConfig = {
  auth: {
    clientId: "9ce7517d-a62d-44a3-bcf5-cf319af6436b", // Replace with your GraphAPI client ID
    authority: "https://login.microsoftonline.com/59034451-9b9d-4095-95cb-cb280da28cc6", // Replace with your tenant ID
    redirectUri: getRedirectUri(),
    
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

const msalInstance = new PublicClientApplication(msalConfig);

export default msalInstance;
